import DefaultPicture from './DefaultPicture';

export default DefaultPicture;
